// packages/web/src/api/me/keys.ts

export const meKeys = {
  all: ["me"] as const,
  week: (userId: string, weekISO: string) => [...meKeys.all, "week", userId, weekISO] as const,
};
